import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const IconCrono = ({ color = colors.white, className, onClick }: IProps) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 700 700"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M593.749 304.088C593.749 309.366 592.299 314.645 589.374 319.376C513.645 442.468 448.759 532.392 349.99 651.204C340.527 662.57 327.45 663.33 318.367 660.263C309.261 657.196 299.346 648.66 298.728 633.919C296.052 571.087 294.833 508.27 295.632 445.403C295.768 434.692 287.101 425.926 276.389 425.971C229.153 426.17 181.923 425.688 134.692 424.874C123.969 424.683 114.482 418.953 109.37 409.585C104.282 400.289 104.567 389.351 110.131 380.316C185.859 257.248 250.746 167.3 349.515 48.4882C358.954 37.123 372.055 36.3621 381.138 39.4293C390.22 42.4965 400.159 51.0323 400.777 65.7739C403.453 128.623 404.675 191.458 403.873 254.343C403.737 265.033 412.371 273.792 423.063 273.764C470.326 273.639 517.575 274.01 564.837 274.843C575.56 275.033 585.023 280.739 590.135 290.107C592.56 294.53 593.749 299.309 593.749 304.088Z"
        fill={color}
      />
    </svg>
  );
};

export default IconCrono;
